import classNames from 'classnames';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'Components/Checkbox/Checkbox';
import Typography from 'Components/Typography/Typography';
import FormContext from './FormContext';
import "./FormCheckbox.css"


const propTypes = {
    /**
     * @default {'form-select'}
     */
    prefix: PropTypes.string,

    /**
     * The FormCheckbox `ref` will be forwarded to the underlying input element,
     * which means unless it will be a DOM node, when resolved.
     *
     * @type {ReactRef}
     * @alias ref
     */
    _ref: PropTypes.any,

    /** A callback fired when the `value` prop changes */
    onChange: PropTypes.func,

    /**
     * The default selected option of the select element
     *
     * @controllable onChange
     * */
    value: PropTypes.string,

    /**
     * Uses `controlId` from `<FormGroup>` if not explicitly specified.
     */
    id: PropTypes.string,

    /** Add "valid" validation styles to the control */
    isValid: PropTypes.bool,

    /** Add "invalid" validation styles to the control and accompanying label */
    isInvalid: PropTypes.bool,
};

const FormCheckbox = React.forwardRef(
    (
        {
            prefix,
            id,
            className,
            value,
            isValid,
            isInvalid,
            isChecked,
            text,
            onChange,
            ...props
        },
        ref,
    ) => {
        const { controlId } = useContext(FormContext);

        prefix = 'form-checkbox';

        const classes = classNames(
            prefix,
            className,
            isValid && `is-valid`,
            isInvalid && `is-invalid`
        )

        return (
            <>
                <div className={classes} onClick={onChange}>
                    <Checkbox id={id || controlId} ref={ref} checked={isChecked} onChange={() => {}}/>
                    <Typography className={"form-checkbox-text"} ref={ref} bold={true}>{text}</Typography>
                </div>
            </>
        );
    },
);

FormCheckbox.displayName = 'FormCheckbox';
FormCheckbox.propTypes = propTypes;

export default FormCheckbox;
